import React from 'react';

import styles from './SectionsForm.module.css';

type Props = {
  children: React.ReactNode;
  onSubmit(): void;
};

export const SectionsFormWrapper: React.FC<Props> = props => {
  const { children, onSubmit } = props;

  const handleSubmit = React.useCallback(
    (event: React.SyntheticEvent) => {
      event.preventDefault();
      onSubmit();
    },
    [onSubmit]
  );

  return (
    <form className={styles.SectionsForm__Wrapper} onSubmit={handleSubmit}>
      {children}
    </form>
  );
};
